import React from 'react'

const Header = () => {
  return (
    <header className="text-white body-font bg-gradient-to-r from-cyan-200 via-blue-300 to-blue-600">
      <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
        <a className="flex title-font font-medium items-center text-white mb-4 md:mb-0" href="/">
          <img className="w-28 md:w-36 " src="/images/logo.png" alt="Bitnea Logo" />
          <span className="ml-3 text-xl"></span>
        </a>
        <nav id="menu" className="md:ml-auto flex flex-wrap items-center text-base justify-center">
          <a href="#inicio" className="mr-5 ml-10 hover:text-cyan-300 transition-colors duration-300">Inicio</a>
          <a href="#planes" className="mr-5 ml-10 hover:text-cyan-300 transition-colors duration-300">Planes</a>
          <a href="#equipo" className="mr-5 ml-10 hover:text-cyan-300 transition-colors duration-300">Nosotros</a>
          <a href="#soporte" className="mr-5 ml-4 hover:text-cyan-300 transition-colors duration-300">Soporte</a>
          <a
            href="#cotizar"
            className="inline-flex items-center text-blue-900 bg-white border-0 py-2 px-4 focus:outline-none hover:bg-blue-700 hover:text-white rounded-full text-base mt-4 md:mt-0 transition-colors duration-300"
          >
            Cotizar
            <svg
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              className="w-4 h-4 ml-1"
              viewBox="0 0 24 24"
            >
              <path d="M5 12h14M12 5l7 7-7 7"></path>
            </svg>
          </a>
        </nav>
      </div>
    </header>
  )
}

export default Header
